"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPORT_COMPONENT_TYPES = void 0;
exports.REPORT_COMPONENT_TYPES = {
    AGGREGATE_COLUMN: 'Aggregate Column',
    COLUMN: 'Column',
    CROSS_FILTER: 'Cross Filter',
    CROSS_FILTER_CRITERIA: 'Cross Filter Criteria',
    CUSTOM_DETAIL_FORMULA: 'Detail Formula',
    CUSTOM_SUMMARY_FORMULA: 'Summary Formula',
    FILTER: 'Filter',
    GROUPING: 'Grouping'
};
//# sourceMappingURL=REPORT_COMPONENT_TYPES.js.map